import gql from 'graphql-tag'

export const GET_TENANT_QUERY = gql`
  query tenant {
    tenant @rest(type: "Tenant", path: "/tenant") {
      id
      entity_type_id
      name
      attributes
    }
  }
`
